export const getSegmentContent = segment => typeof segment === 'string' || 'icon' in segment ? segment : segment.text;
export const isSegmentDisabled = value => typeof value !== 'string' && value.disabled;
//# sourceMappingURL=utils.js.map